<template>
    <v-row>
        <v-col cols="12" md="7">
            <div class="white-card kimsa-elevation pa-3">
                <v-row dense>
                    <v-col cols="6" md="4">
                        <folder-card create-mode @click="showAdminFolders" />
                    </v-col>
                    <v-col cols="6" md="4" v-for="folder in lastFolders" :key="folder.id">
                        <folder-card :folder="folder" :is-active="isActiveFolder(folder)"
                            @click="onSelectFolder(folder)" @click:edit="showAdminFolders(folder)" />
                    </v-col>
                    <v-col cols="6" md="3" v-for="folder in currentFolders" :key="folder.id">
                        <folder-card :folder="folder" :is-active="isActiveFolder(folder)"
                            @click="onSelectFolder(folder)" @click:edit="showAdminFolders(folder)" />
                    </v-col>
                    <v-col cols="12" v-if="pageCount > 1">
                        <kimsa-pagination @page="page = $event - 1" :pageCount="pageCount"
                            :total-visible="isMobile ? 5 : 7" />
                    </v-col>
                </v-row>
            </div>
            <div class="white-card kimsa-elevation pa-3 mt-3">
                <most-used-carousel type="routines"/>
            </div>
        </v-col>
        <v-col cols="12" md="5">
            <div class="white-card kimsa-elevation pa-3 fill-height">
                <routines @loading="loading = $event" :search="search" :folder="folderId" :total-visible-pagination="5"
                    ref="routines" />
            </div>
        </v-col>

        <admin-folders-dialog ref="folders" type="routines" :coach-id="coachId" :folder="currentFolder"
            @hide="currentFolder = null" />
    </v-row>
</template>

<script>
import FolderCard from '@/components/common/cards/FolderCard'
import KimsaPagination from '@/components/common/KimsaPagination'
import Routines from '@/components/coach/routines/Routines';
import AdminFoldersDialog from '@/components/coach/AdminFoldersDialog.vue';
import { mapState, mapActions } from 'vuex';
import MostUsedCarousel from '../MostUsedCarousel.vue';

export default {
    components: { FolderCard, KimsaPagination, Routines, AdminFoldersDialog, MostUsedCarousel },
    name: "RoutinesTab",
    data() {
        return {
            search: '',
            loading: false,
            folderId: null,
            currentFolder: null,
            page: 0,
        }
    },
    computed: {
        ...mapState(['folders']),
        currentFoldersType(vm = this) {
            return vm.folders.filter(folder => folder.type === 'routines') || []
        },
        lastFolders(vm = this) {
            return vm.currentFoldersType.slice(0, 2)
        },
        currentFolders(vm = this) {
            let currentPage = (vm.page * 4) + 2
            return vm.currentFoldersType.slice(currentPage, currentPage + 4)
        },
        coachId(vm = this) {
            return vm.currentUser?.uid || null
        },
        pageCount(vm = this) {
            return Math.ceil((vm.currentFoldersType.length - 2) / 4)
        }
    },
    async mounted() {
        const vm = this;
        if (vm.folders.length === 0) await vm.bindFolders(vm.currentUser.uid)
    },
    methods: {
        ...mapActions(['bindFolders']),
        onSelectFolder(folder) {
            const vm = this
            if (vm.folderId === folder?.id) return vm.folderId = null
            vm.folderId = folder?.id || null
        },
        showAdminFolders(folder) {
            const vm = this
            if (folder) vm.currentFolder = folder
            vm.$refs.folders.show()
        },
        isActiveFolder(folder) {
            const vm = this
            return vm.folderId === folder.id
        },
        setSearch(search) {
            const vm = this;
            vm.search = search
        },
        refresh() {
            const vm = this;
            vm.$refs.routines.refresh()
        }
    },
    watch: {
        loading(val) {
            this.$emit('loading', val)
        },
    },
}
</script>

<style scoped></style>